/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the PreviewIncidentReportImageDto interface.
 */
export function instanceOfPreviewIncidentReportImageDto(value) {
    let isInstance = true;
    return isInstance;
}
export function PreviewIncidentReportImageDtoFromJSON(json) {
    return PreviewIncidentReportImageDtoFromJSONTyped(json, false);
}
export function PreviewIncidentReportImageDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'thumbnailUrl': !exists(json, 'thumbnailUrl') ? undefined : json['thumbnailUrl'],
        'previewUrl': !exists(json, 'previewUrl') ? undefined : json['previewUrl'],
        'width': !exists(json, 'width') ? undefined : json['width'],
        'height': !exists(json, 'height') ? undefined : json['height'],
    };
}
export function PreviewIncidentReportImageDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'thumbnailUrl': value.thumbnailUrl,
        'previewUrl': value.previewUrl,
        'width': value.width,
        'height': value.height,
    };
}
